const PU = process.env.PUBLIC_URL || "";
const p = (...parts: string[]) =>
  `${PU}/${parts.join("/")}`.replace(/\/+/g, "/");
export const img = (project: string, size: 480 | 1600, file: string) =>
  p("media", "projects", project, String(size), file);

export interface Project {
  id: number;
  title: string;
  images: string[];
  previewImage?: string;
  credits?: Record<number, string>;
  description: string;

  builder?: string;
  projektzeitraum?: string;
  leistungen?: string;
  architekt?: string;
  nutzung?: string;
  status?: "abgeschlossen" | "bau" | "planung";

  wohnflaeche?: string;
  nutzflaeche?: string;
  gewerbeeinheiten?: string;
  gewerbeflaeche?: string;
  grundstuecksflaeche?: string;
  bruttoGrundflaeche?: string;
  wohneinheiten?: string;
  wohnungsschluessel?: string;
  anzahlStellplaetze?: string;
  besonderheit?: string[];
  location: string;
}
export const featured: Project[] = [
  {
    id: 1,
    title: "Neubau Dorint Seehotel & Resort Klink an der Müritz",
    images: [
      img("dorint", 1600, "mueritz.webp"),
      img("dorint", 1600, "mueritz3.webp"),
      img("dorint", 1600, "mueritz7.webp"),
      img("dorint", 1600, "mueritz12.webp"),
      img("dorint", 1600, "mueritz19.webp"),
    ],
    previewImage: img("dorint", 1600, "mueritz.webp"),

    description: `Am Ufer der Müritz und 8 km südwestlich von Waren (Müritz) entsteht auf dem 45 Hektar großem Areal des Gesundheits- und Erholungsparks am Müritzufer u.a. das moderne 4-Sterne-Superior Ferien- und Konferenzhotel „Dorint Seehotel & Resort Klink a.d. Müritz“. Der Hotelneubau wird durch die AVILA-Gruppe realisiert und betrieben. Unterstützt wird sie dabei im Management durch die renommierte Dorint-Gruppe. Bis 2017 befand sich auf dem Areal ein FDGB-Ferienheim. Nach der Sprengung des alten Hotels wurde im Jahr 2022 mit dem Bau des neuen Hotels begonnen.

Das Hotel umfasst 215 Gästezimmer – darunter Standarddoppelzimmer, Familienzimmern, Suiten, barrierefreie sowie rollstuhlgerechte Zimmer. Es entsteht ein umfangreiches Angebot für Freizeit- und Businessgäste: ein separater Tagungsbereich mit Tagungsräumen und einer Veranstaltungshalle, einem umfangreichen Spa-Bereich mit Sauna und Fitness, einem großzügigen Gastronomiebereich sowie Außen- und Innenpool. Außerdem gibt es einen separaten Kinderbereich (Kids-World und Teens-Club) und eine Skybar mit Blick auf die Müritz. Der Hotelneubau wird mit 7 oberirdischen abgestaffelten Geschossen (Erdgeschoss + 6 Obergeschosse) sowie mit 2 Untergeschossen errichtet.

Das Hotel wird nach modernsten ökologischen Standards mit einem innovativen Energie- und Versorgungskonzept betrieben. So erfolgt die Wärme- und Kälteversorgung aus einer kombinierten Sole-Wärmepumpe/Kältemaschine, die aus 35 Erdsonden mit einer Tiefe von jeweils 200 m angetrieben wird. Der notwendige Strom für die Wärmepumpe wird aus dem BHKW erzeugt. Die gleichzeitige Wärmeerzeugung des BHKWs wird zur Trinkwasserbereitung verwendet. Nur an den kältesten Tagen kommt ein Spitzenlastkessel (Gas) zum Einsatz.

Im Rahmen der Angebote der nahegelegenen Müritz Klinik und deren ganzheitlichem Gesundheitsprogramm mit Bewegung, gesunder Ernährung und Stressabbau bietet das Areal auch die Möglichkeit, Urlaub an der Müritz zu verbringen mit dem vorrangigen Ziel, die eigene Gesundheit zu erhalten, zu fördern oder wiederherzustellen.`,

    builder: "AVILA Management & Consulting AG",
    projektzeitraum: "September 2022 – Februar 2027",

    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement, Veranstaltungsorganisation",

    architekt:
      "Hochbau: Reichel Architekten, Dieter Reichel, ign Melzer Voigtländer Winter Lüttich Stadtplaner, Architekten & Ingenieure PartGmbB. Innenausstattung: DBLB Planungsgesellschaft mbH & Kitzig Interior Design GmbH",

    nutzung: "Hotel",
    wohneinheiten: "215 Zimmer",
    wohnflaeche: "ca. 26.960 m²",
    grundstuecksflaeche: "ca. 56.459 m²",

    anzahlStellplaetze:
      "250 Außenstellplätze, 19 am Hotel, 24 Tiefgaragenstellplätze und 5 Außenstellplätze für Busse",

    besonderheit: [
      "50 Meter vom Hoteleigenen Badestrand entfernt",
      "In unmittelbarer Nähe der „Müritz Klinik“ – Fachklinik für Prävention und Rehabilitation",
    ],

    status: "bau",
    location: "Am Seeblick 1, 17192 Klink",
  },

  {
    id: 2,

    title: "Sanierung und Neubau Wohnpark „St. Marien“",

    images: [
      img("marien", 1600, "marien-01.webp"),
      img("marien", 1600, "marien-02.webp"),
      img("marien", 1600, "marien-03.webp"),
      img("marien", 1600, "marien-05.webp"),
      img("marien", 1600, "marien-10.webp"),
    ],

    previewImage: img("marien", 1600, "marien-01.webp"),

    location:
      "Silbersteinstr. / Mariendorfer Weg, 12051 Berlin-Neukölln / Eschersheimer Weg, 12099 Berlin-Neukölln",

    credits: {
      0: "AVILA Projektmanagement GmbH / euroluftbild.de",
    },

    description: `
Das Bauvorhaben Mariendorfer Weg umfasst den Neubau von Wohnungen inklusive Tiefgarage sowie die Sanierung und den Umbau denkmalgeschützter Bestandsgebäude zu Wohnungen. In Zusammenarbeit mit dem Bezirk Neukölln wurden in zwei Bauabschnitten 598 moderne Mietwohnungen zwischen der Silbersteinstraße im Norden und dem Mariendorfer Weg im Süden realisiert. Dieses Vorhaben wird in zwei zeitlich versetzten Abschnitten umgesetzt.

Erster Bauabschnitt: Sanierung der historischen Klinikgebäude

Der erste Bauabschnitt fokussierte sich auf die Sanierung der denkmalgeschützten Gebäudeanlage der ehemaligen Brandenburgischen Hebammen-Lehranstalt und Frauenklinik. Die zwischen 1914 und 1917 errichteten Gebäude – bestehend aus Entbindungshaus, Verwaltungsgebäude und Direktorenwohnhaus – sind seit der Schließung 2005 als Gesamtanlage unter Denkmalschutz gestellt. Das Sanierungskonzept wurde unter Berücksichtigung der städtebaulichen und denkmalpflegerischen Belange entwickelt. Die historischen Bauteile, ursprünglich durch lange Flure geprägt, wurden für kleinteilige Wohnnutzungen umgebaut und teilweise restauriert. Es entstanden die Häuser „Clara“ & „Elisabeth“. Ergänzend entstand ein modernes Bauwerk, das sich harmonisch in die Gesamtanlage einfügt. Zudem wurde in der ehemaligen Direktorenvilla eine Kindertagesstätte integriert.

Zweiter Bauabschnitt: Neubau mit vielfältigen Wohnformen

Im nördlich angrenzenden zweiten Bauabschnitt entstanden Neubauten „Haus Ursula“, „Haus Teresa“, „Haus Anna“ unterschiedlicher Typologien sowie ein Studentenwohnheim „Edith Stein“ mit ca. 137 Wohneinheiten an der Silbersteinstraße. Zwischen der geraden Bebauung im Norden und dem historischen Denkmal im Süden wurden offene Punkthäuser errichtet, die von großzügigen Freiflächen umgeben sind. Diese Planung schafft eine hohe Wohnqualität, ohne die Präsenz des Denkmals zu beeinträchtigen. Als markantes Wahrzeichen wurde am nordwestlichen Rand des Quartiers ein 65 Meter hoher Solitär „Haus Ruth“ mit insgesamt 71 exklusiven Wohnungen in 21 Ober- und 2 Untergeschossen errichtet, der weithin sichtbar das neue Wohngebiet prägt.

Infrastruktur und Gemeinschaft

Alle Wohngebäude sind über eine großzügige Tiefgarage mit 475 PKW-Stellplätzen miteinander verbunden. Durch diese Unterkellerung bleibt das Quartier frei von parkenden Autos und bietet stattdessen hochwertige Grünanlagen mit parkartigem Charakter, Sport- und Spielbereiche. Ein befahrbares Wegesystem gewährleistet die Erschließung für Anwohner und Rettungskräfte.

Zusätzlich stehen großzügige Gemeinschafts- und Aufenthaltsflächen sowie ein Familienzentrum im Erdgeschoss des Wohnkomplexes zur Verfügung, die sowohl von Studierenden als auch jungen Familien genutzt werden können.
`,

    builder: "petruswerk GmbH & Co. Mariendorfer Weg KG",

    projektzeitraum: "2017–2021",

    leistungen:
      "Projektentwicklung, Projektleitung und -steuerung, GU, Objektbetreuung & Gewährleistungsmanagement",

    architekt: "GFB Alvarez & Schepers",

    nutzung: "Wohnen und Gewerbe",
    status: "abgeschlossen",

    wohnflaeche: "45.960 m² Wohnfläche und ca. 1.726 m² Gewerbefläche",

    grundstuecksflaeche: "ca. 39.575 m²",

    wohneinheiten: "598",

    anzahlStellplaetze: "475",
  },
  {
    id: 3,
    title: "Neubau Wohnanlage „St. Hedwig“ Gartenstadt Falkenberg",
    images: [
      img("hedwig", 1600, "hedwig.webp"),
      img("hedwig", 1600, "hedwig-01.webp"),
      img("hedwig", 1600, "hedwig-03.webp"),
    ],
    previewImage: img("hedwig", 1600, "hedwig.webp"),

    credits: {
      0: "AVILA Projektmanagement GmbH / euroluftbild.de",
    },

    location:
      "Paradiesstraße, Johannes-Tobei-Straße u.a., 12526 Berlin-Bohnsdorf",

    description: `
Im Süden Berlins, im Ortsteil Bohnsdorf (Bezirk Treptow-Köpenick), wurde die exklusive Wohnanlage „St. Hedwig“ entlang der Johannes-Tobei-Straße Ecke Paradiesstraße und in unmittelbarer Nähe zum St. Hedwig Krankenhaus errichtet. Die Anlage umfasst 41 hochwertig ausgestattete Häuser, verteilt auf zwei- bis dreigeschossige Mehrfamilienhäuser mit jeweils vier bis sechs Wohneinheiten, insgesamt 226 Wohnungen sowie 18 Gewerbe- und Büroeinheiten.

Die Wohnflächen reichen von 48 m² bis 82 m² und zeichnen sich durch lichtdurchflutete Räume, bodentiefe Fenster sowie großzügige Terrassen und Balkone aus. Die Wohnungen im Erdgeschoss bieten zusätzlich einen eigenen Gartenanteil. Die hohe Lebensqualität in der Anlage wird durch weitläufige und parkähnliche Grünflächen mit 4 Spielplätzen unterstrichen.

Hintergrund: In unmittelbarer Nachbarschaft, nördlich des namensgebenden Falkenberges, ließ der Architekt Bruno Taut ab 1912 die Gartenstadt Falkenberg erbauen, die im Juli 2008 zusammen mit fünf weiteren Siedlungen der Berliner Moderne in die Liste des UNESCO-Weltkulturerbes aufgenommen wurde.
`,

    builder:
      "petruswerk Katholische Wohnungsbau- und Siedlungsgesellschaft mbH",

    projektzeitraum: "2018-2021",

    leistungen:
      "Projektentwicklung, Projektleitung und -steuerung, GU, Objekt-betreuung & Gewährleistungsmanagement",

    architekt: "Büro QBQ Quick Bäckmann Quick und Partner, Partner",

    nutzung: "Wohnen, Büro & Gewerbe",
    status: "abgeschlossen",

    wohnflaeche: "ca. 16.868 m²",
    gewerbeflaeche: "ca. 919 m²",
    grundstuecksflaeche: "ca. 31.049 m²",

    wohneinheiten: "226",
    anzahlStellplaetze: "183 Außenstellplätze",
  },
  {
    id: 4,
    title: 'Neubau von drei Stadtvillen "Wohnen am Koenigssee"',
    images: [
      img("winklerstr", 1600, "winklerstr2.webp"),
      img("winklerstr", 1600, "winklerstr3.webp"),
      img("winklerstr", 1600, "winklerstr5.webp"),
    ],
    previewImage: img("winklerstr", 1600, "winklerstr2.webp"),
    description: `Mitten im ruhigen und grünen Berliner Stadtteil Grunewald entstand in der Winklerstraße 6 ein exklusives Ensemble aus drei eleganten Stadtvillen mit insgesamt 16 luxurösen und repräsentativ ausgestatteten Wohneinheiten – ein Wohnprojekt, das klassische Architektur mit modernem Wohnkomfort vereint und dennoch gleichzeitig verkehrsgünstig gelegen ist. Der S-Bahnhof Grunewald befindet sich fast vor der Haustür. Über die AVUS und Stadtautobahn sind sowohl die Berliner City als auch die Flughäfen schnell erreichbar. Das nahegelegene Roseneck bietet vielfältige Einkaufsmöglichkeiten, gastronomische Angebote sowie Arztpraxen, Schulen und Kindergärten – alles in fußläufiger Umgebung. Der Kurfürstendamm und der Halensee liegen ebenfalls nur wenige Minuten entfernt.

  Das ruhig gelegene Wohnensemble wurde auf einem parkartigen Hanggrundstück mit altem Baumbestand errichtet und orientiert sich gestalterisch an den repräsentativen Villenbauten des 19. Jahrhunderts – interpretiert in zeitgemäßer Architektursprache.

  Alle drei Stadtvillen sind dreigeschossig mit einem zurückgesetzten Dachgeschoss. Die beiden vorderen Häuser umfassen jeweils sieben hochwertige Wohneinheiten, während sich im dritten Gebäude drei großzügige Maisonette-Wohnungen befinden. Alle Gebäude sind voll unterkellert, eine Tiefgarage sorgt für den nötigen Komfort und ermöglicht für jede Wohneinheit mindestens einen Pkw-Stellplatz. Ein Aufzug führt bequem von der Tiefgarage bis in jede Etage.

  Die Wohnungen zeichnen sich durch eine hochwertige und zugleich stilvolle Ausstattung aus. Großzügig geschnittene Grundrisse mit zwei voll ausgestatteten Bädern und einem zusätzlichen Gäste-WC bieten viel Raum und Komfort. In den Wohnbereichen sorgt edles Parkett in Kombination mit einer Fußbodenheizung für eine warme, behagliche Atmosphäre. Die offenen Küchen sind modern gestaltet und mit hochwertigen Einbauten, Unterschränken, Oberschränken sowie einem Tresen versehen – sie fügen sich harmonisch in das Wohnambiente ein. Großflächige Fensterflächen lassen viel Tageslicht in die Räume und schaffen ein helles, freundliches Wohngefühl. Für besondere Gemütlichkeit sorgt ein moderner, offener Kamin im Wohnbereich. Die stilvollen Badezimmer sind in eleganter Marmorausführung gestaltet und verfügen über sowohl eine Dusche als auch eine Badewanne.

  Je nach Lage der Wohnung genießen die Bewohner entweder eine Terrasse im Erdgeschoss oder einen Balkon in den oberen Etagen mit Blick ins Grüne. Das Highlight der Dachgeschosswohnungen sind großzügige Panoramaterrassen mit Ausblick auf den nahegelegenen Königssee.`,
    builder: "petruswerk GmbH & Co. Winkler Str. 6 KG",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement",
    architekt:
      "Architektur und Innenraumplanung Veit M.F. Seeberger, Architekt BDB, Berlin",
    status: "abgeschlossen",
    projektzeitraum: "2008",
    nutzung: "Eigentumswohnungen",
    wohneinheiten: "16",
    anzahlStellplaetze: "20 Tiefgaragenplätze",
    wohnflaeche: "ca. 2.560 m²",
    grundstuecksflaeche: "ca. 6.172 m²",
    location: "Winklerstraße 6 und 4b, Hasensprung 4, 14193 Berlin-Grunewald",
  },
  {
    id: 5,
    title: "Neubau Wohnpark für Betreutes Wohnen „St. Teresa“",

    images: [
      img("teresa", 1600, "goetzstrasse-03.webp"),
      img("teresa", 1600, "goetzstrasse-04.webp"),
      img("teresa", 1600, "goetzstrasse-05.webp"),
      img("teresa", 1600, "goetzstrasse-06.webp"),
    ],

    previewImage: img("teresa", 1600, "goetzstrasse-03.webp"),

    location: "Götzstraße 65-75, Felixstraße 33-39, 12099 Berlin-Tempelhof",

    description: `
Mit dem AVILA Wohnpark St. Teresa ist im Herzen von Berlin-Tempelhof ein modernes Quartier für altersgerechtes Wohnen entstanden – durchdacht geplant, hochwertig umgesetzt und konsequent auf die Bedürfnisse älterer Menschen ausgerichtet.

Idyllisch gelegen zwischen Gärten und grünen Wohnzeilen, vereint der Wohnpark das Beste aus drei Welten: Gemeinschaft, wenn man sie sucht – Unterstützung, wenn man sie braucht – und Ruhe, wann immer man sie wünscht. Insgesamt sind 181 altersgerechte Wohnungen in neun dreigeschossige Wohnhäuser mit Staffelgeschoss sowie ein zweigeschossiges Begegnungszentrum entstanden. Alle Gebäude wurden voll unterkellert und gemäß DIN 77800 (Qualitätsanforderungen an Wohnformen für ältere Menschen) errichtet.

Die komfortablen Zwei-Zimmer-Wohnungen mit 43 bis 80 m² Wohnfläche sind barrierefrei konzipiert und mit modernen, altersgerechten Ausstattungsmerkmalen versehen – etwa mit ebenerdigen Duschbädern, Aufzügen in jedem Haus und großzügigen Balkonen oder Terrassen mit Blick ins Grüne.

Ein besonderes Merkmal des Wohnparks ist die Kapelle St. Teresa, die im Zentrum der Wohnanlage errichtet wurde. Sie wird von den Ordensschwestern der „Kleinen Blume von Bethanien“ genutzt, die auf dem Gelände leben und dort seelsorgerische Angebote für die Bewohnerinnen und Bewohner des Wohnparks bereitstellen.

Für zusätzliche Sicherheit sorgt ein 24-Stunden-Hausnotrufsystem. Ergänzt wird das Angebot durch den Malteser Hilfsdienst vor Ort, der sowohl im Alltag unterstützt als auch Beratung in allen Lebenslagen bietet.

Ein Highlight des Wohnparks ist das zentrale Begegnungszentrum, mit der sozialen Teilhabe im Fokus. Hier finden regelmäßig Veranstaltungen, kulturelle Angebote und Ausflüge statt – organisiert durch die Malteser, die auch psychosoziale Begleitung und Freizeitgestaltung anbieten. So wird selbstbestimmtes Wohnen bis ins hohe Alter mit einem aktiven, gemeinschaftlichen Leben verbunden.

Damit bietet der AVILA Wohnpark St. Teresa nicht nur hohen Wohnkomfort und Barrierefreiheit, sondern auch ein besonderes Maß an spiritueller Begleitung, Gemeinschaft und menschlicher Nähe – Werte, die gerade im Alter an Bedeutung gewinnen.

Der Wohnpark liegt in direkter Nähe zum Tempelhofer Feld sowie zu Ärzten, Apotheken, Einkaufsmöglichkeiten und öffentlichen Verkehrsmitteln – ein hauseigener Tiefgaragenstellplatz sorgt zudem für kurze Wege und zusätzlichen Alltagskomfort.
`,

    builder: "AVILA Management & Consulting AG",

    projektzeitraum: "2008",

    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement",

    architekt: "Büro QBQ Quick Bäckmann Quick und Partner, Berlin",

    nutzung: "Betreutes Wohnen",
    status: "abgeschlossen",

    wohnflaeche: "Wohnfläche: ca. 9.462 m²",
    gewerbeflaeche: "Gewerbefläche: ca.410 m²",

    grundstuecksflaeche: "ca. 16.135 m²",

    wohneinheiten: "181",

    anzahlStellplaetze: "49 Tiefgaragenstellplätze",

    besonderheit: [
      "2 Gewerbeeinheiten: Zentralgebäude mit Begegnungszentrum, Büros und Schwesternwohnungen",
    ],
  },
  {
    id: 6,
    title:
      "Neubau Wohnpark für Betreutes Wohnen „St. Paulus“ am Dorfanger Alt-Lankwitz",
    images: [
      img("paulus", 1600, "altlankwitz02.webp"),
      img("paulus", 1600, "altlankwitz05.webp"),
    ],
    previewImage: img("paulus", 1600, "altlankwitz02.webp"),
    description: `Auf dem historischen Gelände des ehemaligen Klosters Lankwitz ist eine moderne, barrierefreie Wohnanlage für Senioren entstanden.  Der Malteser Hilfsdienst ist vor Ort Ansprechpartner und unterstützt in allen Lebenslagen. Das Projekt umfasst insgesamt 87 Wohneinheiten in vier Wohngebäuden, verteilt auf verschiedene Gebäudetypen, und verbindet zeitgemäße Wohnqualität mit der spirituellen und sozialen Tradition des Ortes. Bereits im früheren Theodosius-Krankenhaus, das sich direkt auf dem Gelände befand, wurden über Jahrzehnte pflegebedürftige Menschen liebevoll betreut. Diese Tradition wird nun fortgeführt – nicht nur durch die soziale Ausrichtung der Wohnanlage, sondern auch durch die Präsenz des Ordens Chemin Neuf, der die seelsorgerische Begleitung der Bewohner übernimmt.

  
    Die Wohnanlage befindet sich in ruhiger Lage im historischen Dorfkern von Berlin-Lankwitz und der Standort ist geprägt von altem Baumbestand, einem privaten Klosterfriedhof, der mittelalterlichen Dorfkirche und dem angrenzenden Klostergarten, der über Jahrzehnte von den Ordensschwestern gepflegt wurde und weiterhin ein Ort der Ruhe und Besinnung bleibt.

  Das Ensemble gliedert sich in drei Hauptbereiche:
Das Angerhaus: Auf dem Platz des ehemaligen Theodosius-Heims entstand ein viergeschossiges Gebäude mit zwei Vollgeschossen, Dach- und Kellergeschoss. Es beherbergt Büros, einen Gemeinschaftsraum, der auch als Kapelle genutzt werden kann, sowie 11 barrierefreie Wohnungen in den oberen Etagen. Ergänzt wird das Haus durch ein Begegnungszentrum, das Raum für gemeinschaftliche Aktivitäten bietet.

  Die Atriumhäuser (Flügelhaus): Drei miteinander verbundene Gebäudeflügel mit jeweils drei Vollgeschossen, einem Kellergeschoss und einer Tiefgarage mit 55 Stellplätzen bilden diesen Bereich. Insgesamt wurden hier 75 barrierefreie Wohnungen mit Größen zwischen 45 und 60 m² realisiert. Die Architektur orientiert sich an einem offenen Innenhofprinzip und fördert Austausch und Begegnung unter den Bewohnern.

 Alle Wohnungen der Anlage sind barrierefrei und verfügen über zwei bis drei Zimmer mit Wohnflächen zwischen 45 und 88 m². Hochwertige Ausstattungsmerkmale wie Parkettböden, bodengleiche Duschen, Einbauküchen, Balkone oder Terrassen sowie ein 24-Stunden-Hausnotruf sorgen für Sicherheit und Wohnkomfort. Alle Gebäude sind mit Aufzügen ausgestattet, die bis in die Tiefgarage bzw. den Keller führen. So ist in Alt-Lankwitz ein Ort entstanden, der das Erbe des Standorts achtet und gleichzeitig modernen, selbstbestimmten Lebensraum für ältere Menschen bietet – eingebettet in eine grüne Umgebung mit starker sozialer und spiritueller Verankerung.`,
    builder: "AVILA Management & Consulting AG",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement",
    architekt: "Architekt Bert Lehmann der Bürogemeinschaft Krüger & Lehmann",
    nutzung: "Betreutes Wohnen",
    status: "abgeschlossen",
    projektzeitraum: "2008",
    wohneinheiten: "87",
    anzahlStellplaetze: "55",
    wohnflaeche: "ca. 5.086 m²",
    gewerbeflaeche: "ca. 36 m²",
    grundstuecksflaeche: "ca. 9.428 m²",
    location: "Am Dominikuskloster, Alt-Lankwitz 31-34,12247 Berlin-Lankwitz",
  },

  {
    id: 7,
    title: "Neubau AVILA Studentenwohnpark „Edith Stein“",
    images: [
      img(
        "studentenwohnparkgreifswald",
        1600,
        "greifswald-anklamerstr-03.webp"
      ),
      img(
        "studentenwohnparkgreifswald",
        1600,
        "greifswald-anklamerstr-05.webp"
      ),
    ],
    previewImage: img(
      "studentenwohnparkgreifswald",
      1600,
      "greifswald-anklamerstr-03.webp"
    ),

    location:
      "Anklamer Straße 75-76 / Johann-Stelling-Str. 30, 17489 Greifswald",

    description: `
Auf dem ehemaligen Reichsbahngelände an der Anklamer Straße 75–76 / Johann-Stelling-Straße 30 ist ein moderner Studentenwohnpark mit 303 Ein- und Zweizimmerwohnungen sowie einer Gewerbeeinheit in insgesamt sieben Gebäuden entstanden. Der AVILA Wohnpark liegt zentrumsnah in der Hansestadt Greifswald – alle universitären Einrichtungen sind fußläufig oder mit dem Fahrrad erreichbar.

Die Umsetzung erfolgte in zwei Bauabschnitten:

1. Bauabschnitt: Anklamer Straße 75/76 (Haus 1–6)

Im Fokus stand die Sanierung eines denkmalgeschützten Gebäudes (Haus 1) und die Errichtung von fünf Neubauten (Haus 2–6). Das historische Gebäude aus der Zeit um 1900 – ursprünglich als Krankenhaus errichtet und später von der Deutschen Bahn genutzt – wurde in enger Abstimmung mit der Denkmalpflege zu einem modernen Wohnhaus für Studierende umgebaut.

Der neogotische Ziegelbau mit reich ornamentierten Sichtmauerwerksfassaden wurde umfassend modernisiert: neue isolierverglaste Holzfenster, Erneuerung der Haustechnik, Ausbau des Dachgeschosses und Sanierung der historischen Decken- und Dachkonstruktionen. Die ursprüngliche Raumstruktur mit zwei Treppenhäusern und Mittelflurerschließung wurde in zeitgemäße Wohneinheiten umgewandelt.

Ergänzt wird das Ensemble durch innovative Wohnkonzepte in den Neubauten:

· Dorfmaisonetten: zweigeschossige Wohneinheiten mit separatem Eingang und Fahrradstellplatz in einem dorfähnlichen Innenhof.

· Reihenstudios: kompakte Apartments, erschlossen über Laubengänge – „Gassen in der Höhe“ – mit offenen Wohnbereichen.

· WG- und Paar-Appartements: kombinieren gemeinschaftliche Bereiche mit privaten Rückzugsräumen; barrierefreie Wohnungen im EG, großzügige Penthäuser im DG.

Das Gesamtkonzept fördert durch gemeinschaftliche Außenbereiche, Fahrrad- und Waschräume sowie modulare Stadtmöbel ein lebendiges, nachbarschaftliches Wohnen.

2. Bauabschnitt: Johann-Stelling-Straße 30 (Haus 7)

Das ehemalige Reichsbahndirektionsgebäude von 1935 wurde denkmalgerecht saniert und in 50 Studentenwohnungen sowie eine Hausmeisterwohnung umgewandelt. Der fünfgeschossige, verputzte Backsteinbau bildet heute das architektonische Zentrum des Wohnparks. Auch dieses Gebäude war ursprünglich ein Krankenhaus und diente später der Bahnverwaltung.

Im Zusammenspiel aus sechs Neubauten, der Sanierung des historischen Bahngebäudes und der Umnutzung eines denkmalgeschützten Stellwerks entstand ein vielseitiger, identitätsstiftender Wohncampus für Studierende in Greifswald.
`,

    builder:
      "petruswerk Katholische Wohnungsbau- und Siedlungsgesellschaft mbH",

    projektzeitraum: "2011–2015 (Sanierung und Neubau)",

    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement",

    architekt:
      "Neubau: boka Generalplaner GmbH, Matthias Karch, Berlin; Sanierung: Dipl.-Ing. Architekt Thorsten Labs, Falkensee",

    nutzung: "Studenten Apartments",
    status: "abgeschlossen",

    wohnflaeche: "Wohnfläche: ca. 7.495 m² / Gewerbefläche: ca.143 m²",
    grundstuecksflaeche: "ca. 9.388 m²",
    wohneinheiten: "303",
    anzahlStellplaetze: "25",
  },
  {
    id: 8,
    title: "Neubau Wohnpark „St. Elisabeth“",
    images: [
      img("elisabeth", 1600, "nussfertig-01.webp"),
      img("elisabeth", 1600, "nussfertig-02.webp"),
      img("elisabeth", 1600, "nussfertig-04.webp"),
      img("elisabeth", 1600, "nussfertig-05.webp"),
    ],
    previewImage: img("elisabeth", 1600, "nussfertig-01.webp"),
    description: `Inmitten des traditionsreichen Berliner Villenviertels Westend entstand mit dem AVILA Wohnpark St. Elisabeth ein anspruchsvolles Neubauensemble auf dem Gelände einer ehemaligen Klinik. Zwischen Nussbaum-, Akazien- und Kirschenallee wurden drei villenartige Einzelbauten errichtet, die sich harmonisch in das grüne, historisch gewachsene Umfeld einfügen.

  Die architektonisch zurückhaltenden, viergeschossigen Baukörper mit aufgesetztem Staffelgeschoss zeichnen sich durch helle Fassaden, großzügige Fensterflächen sowie weitläufige Balkone und Terrassen aus. Insgesamt beherbergen die Gebäude 32 moderne, größtenteils barrierefreie Mietwohnungen, überwiegend in Form großzügiger Drei-Zimmer-Grundrisse mit Wohnflächen zwischen 103 und 129 Quadratmetern. Die Deckenhöhe von 2,60 Metern und bodentiefe, dreifach verglaste Fenster sorgen für eine helle und freundliche Wohnatmosphäre. Die meisten Wohnungen bieten einen unverbaubaren Blick auf die historische Parkanlage mit ihrem teils denkmalgeschützten Baumbestand, der zum Teil bis ins Jahr 1900 zurückreicht.

  Der Wohnpark St. Elisabeth vereint klassisches Villenflair mit zeitgemäßem Wohnkomfort. Die Wohnungen verfügen über Tageslichtbäder mit separater Dusche, teilweise auch über ein zusätzliches Gäste-WC. Edles Eichenparkett in den Wohn- und Schlafzimmern, hochwertige Fliesen in Küchen und Korridoren sowie eine angenehme Fußbodenheizung schaffen eine hochwertige, behagliche Atmosphäre. In den Erdgeschosswohnungen wurden Sicherheitsglaselemente eingesetzt; alle Wohnungseingangstüren erfüllen die Anforderungen der Widerstandsklasse 2. Die Küchen in den Häusern B und C sind für Kochinseln vorbereitet, und in den Bädern finden sich Anschlüsse für Waschmaschine und Trockner. Auch die digitale Infrastruktur wurde berücksichtigt: Alle Wohnräume sind an das Breitbandkabelnetz angeschlossen und für moderne Kommunikationstechnik vorverkabelt.

  Die drei Gebäude wurden überwiegend aus Kalksandstein errichtet und erfüllen die Anforderungen der Energieeinsparverordnung von 2009. Beheizt wird das Ensemble über einen Anschluss an das Fernwärmenetz der Vattenfall AG. Sämtliche Etagen sowie die Kellergeschosse sind bequem über Aufzüge erreichbar. Die hauseigene Tiefgarage mit 32 Stellplätzen bietet zusätzlichen Komfort und macht den Wohnpark besonders attraktiv für eine urbane Zielgruppe, die auf moderne Standards ebenso Wert legt wie auf stilvolles Wohnen im Grünen.

  Der AVILA Wohnpark St. Elisabeth ist ein gelungenes Beispiel für die behutsame Nachverdichtung in einer der charmantesten Wohnlagen Berlins – naturnah, stilvoll und mit hoher Lebensqualität.`,
    builder: "Dr. Fernando International GmbH",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement",
    architekt: "Büro Reichel + Stauth",
    status: "abgeschlossen",
    projektzeitraum: "2015",
    nutzung: "Mehrgeschossiger Wohnungsbau",
    wohnflaeche: "ca. 3.847 m²",
    grundstuecksflaeche: "ca. 4.804 m²",
    wohneinheiten: "32",
    anzahlStellplaetze: "32 Tiefgaragenstellplätze",
    location: "Nussbaumallee 37, 39, Akazienallee 40, 14050 Berlin-Westend",
  },

  {
    id: 9,
    title:
      "Umbau, Sanierung und Erweiterung der Wohnanlage „Am Kütertor“ Stralsund",
    images: [
      img("kuetertor", 1600, "kuertertor01.webp"),
      img("kuetertor", 1600, "kuertertor02.webp"),
      img("kuetertor", 1600, "kuertertor03.webp"),
      img("kuetertor", 1600, "kuertertor04.webp"),
    ],
    previewImage: img("kuetertor", 1600, "kuertertor01.webp"),
    description: `Das Projekt umfasst die erfolgreiche Sanierung, den Umbau und die Erweiterung des denkmalgeschützten Gebäudekomplexes der ehemaligen Jugendherberge am Kütertor in Stralsund. Entstanden ist ein hochwertiges und generationenübergreifendes Wohnensemble mit 24 Wohneinheiten, einer Gewerbeeinheit und sieben Garagenstellplätzen. Der Standort vereint historische Gebäude wie die Stralsunder Wasserkunst, das Kütertor, das Mauerhaus, den Wasserturm und Teile der Stadtmauer, die durch ihre städtebauliche und historische Bedeutung herausragen.

Der Gebäudekomplex, der bis 2003 der Jugendherberge diente, befand sich in einem desolaten Zustand, bedingt durch intensive Nutzung und zahlreiche frühere Umbauten. Unter denkmalpflegerischer Betreuung wurde die Substanz fachgerecht freigelegt und entkernt, um sie für die neue Nutzung vorzubereiten. Zwei Neubauten ergänzen das Areal und vervollständigen es sowohl städtebaulich als auch funktional.

Das Ergebnis ist eine moderne, generationenübergreifende Wohnanlage, die besonderen Wert auf Funktionalität und Energieeffizienz legt. Das vielfältige Wohnangebot richtet sich an junge Bewohner, Familien und ältere Menschen und bietet ein starkes Identifikationspotenzial. Durch die gelungene Integration des historischen Ambientes fühlen sich die Bewohner in ihrem neuen Zuhause auf diesem einzigartigen Areal bestens aufgehoben.`,
    builder: "petruswerk Grundbesitz GmbH & Co. KG",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement",
    architekt: "gmw planungsgesellschaft mbh",
    status: "abgeschlossen",
    projektzeitraum: "2016",
    nutzung: "Mehrgeschossiger Wohnungsbau",
    wohneinheiten: "24",
    anzahlStellplaetze: "7",
    wohnflaeche: "ca. 1.981 m²",
    gewerbeflaeche: "ca. 135 m²",
    grundstuecksflaeche: "ca. 2.760 m²",
    location: "Am Kütertor 1, Am Wall, Mühlenstraße 24, 18439 Stralsund",
  },
  {
    id: 10,
    title: "Neubau Wohnpark St. Otto – Wohnen am Schweizerhofpark",
    images: [
      img("otto", 1600, "otto-04.webp"),
      img("otto", 1600, "otto-03.webp"),
      img("otto", 1600, "otto-05.webp"),
    ],
    previewImage: img("otto", 1600, "otto-04.webp"),

    location:
      "Johannesstraße 15-21 und Johannesstraße 22, 14165 Berlin-Zehlendorf",

    description: `
In einer der begehrtesten Wohnlagen Berlins – am Rande des Schweizerhofparks in Berlin-Zehlendorf – und auf dem Gelände eines ehemaligen Seniorenheims ist mit der Wohnpark St. Otto ein modernes, hochwertiges Wohnquartier mit insgesamt 81 seniorengerechten Wohnungen entstanden. Das Projekt wurde vom Petruswerk auf zwei benachbarten Grundstücken realisiert, die durch einen öffentlichen Park voneinander getrennt sind. Die Bebauung berücksichtigt den alten Baumbestand sowie die umliegende Nachbarstruktur und fügt sich harmonisch in die grüne Umgebung ein. Die Anlage besteht aus sieben freistehenden, dreigeschossigen Wohngebäuden in solider Massivbauweise und bietet mit durchdachter Architektur und Ausstattung ein komfortables Wohnumfeld für Senioren.

Das Bauvorhaben wurde in zwei Bauabschnitten mit insgesamt drei Baufeldern. Zum Einsatz kamen dabei zwei Haustypen: Punkthäuser mit je drei großzügigen 4-Zimmer-Wohnungen mit ca. 115 m² Wohnfläche, Küche sowie zwei Bädern pro Gebäude und Zeilenhäuser mit je 18 Wohnungen mit 2 und 3 Zimmern, Küche und Bad pro Gebäude.

Die Wohnungen sind nach DIN 18040 Teil 2 seniorengerecht konzipiert und bieten funktionale Grundrisse mit hohem Wohnkomfort.

Bauabschnitt 1 – Baufelder A und B

Der erste Bauabschnitt umfasst die Baufelder A und B und besteht aus sechs dreigeschossigen, unterkellerten Wohngebäuden mit insgesamt 63 Wohneinheiten.

Baufeld A – Johannesstraße 15–19

Auf dem Baufeld A sind fünf Gebäude (zwei Zeilenhäuser und drei Punkthäuser) mit insgesamt 45 Wohneinheiten entstanden. Die Erschließung erfolgt über eine neu angelegte Feuerwehrzufahrt von der Johannesstraße bzw. der Leo-Baeck-Straße. Unter den Häusern befindet sich eine gemeinsame Tiefgarage mit 58 Stellplätzen, die über Sicherheitsschleusen direkt mit den jeweiligen Gebäuden verbunden ist.

Baufeld B – Johannesstraße 21

Auf dem Baufeld B ist ein Zeilenhaus mit 18 Wohneinheiten realisiert.

Bauabschnitt 2 – Baufeld C

Baufeld C – Johannesstraße 22

Als Erweiterung zum ersten Bauabschnitt wurde ein weiteres Zeilenhaus (Haus 7) mit 18 Wohneinheiten errichtet. Auch dieses Gebäude ist über eine Feuerwehrzufahrt erschlossen.

Alle Wohnungen verfügen über Balkone oder Terrassen, die den Blick auf die gemeinschaftlich genutzten, parkartig gestalteten Außenanlagen freigeben. Die gesamte Wohnfläche der Anlage beträgt ca. 6.140 m². Die Wohnanlage wurde gemäß den Anforderungen des Erneuerbare-Energien-Wärmegesetzes (EEWärmeG) errichtet und erfüllt damit moderne energetische Standards. Mit ihrer durchdachten Planung, hochwertigen Ausstattung und der Lage inmitten einer gewachsenen, grünen Umgebung bietet die Wohnanlage St. Otto zeitgemäßes, ruhiges Wohnen für Menschen mit Anspruch – besonders für Senioren, die Wert auf Barrierefreiheit, Komfort und Lebensqualität legen.
`,

    builder:
      "petruswerk Katholische Wohnungsbau- und Siedlungsgesellschaft mbH und Avila Management & Consulting AG",
    projektzeitraum: "2016–2020",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement",

    architekt: "Büro QBQ Quick Bäckmann Quick und Partner, Berlin",

    nutzung: "Mehrgeschossiger Wohnungsbau",
    status: "abgeschlossen",

    wohnflaeche: "ca. 6.140 m²",
    grundstuecksflaeche: "ca. 20.288 m²",
    wohneinheiten: "81",
    anzahlStellplaetze: "58",
  },
  {
    id: 11,
    title:
      "Neubau Wohnquartiers „AVILA Carrée“ Haus Elijas / Haus Edith Stein an der Thaerstraße",
    images: [
      img("carree", 1600, "CARRE02.webp"),
      img("carree", 1600, "CARRE04.webp"),
      img("carree", 1600, "CARRE05.webp"),
      img("carree", 1600, "CARRE06.webp"),
    ],
    previewImage: img("carree", 1600, "CARRE02.webp"),
    description: `Auf dem traditionsreichen Gelände des ehemaligen Zentralvieh- und Schlachthofs in Berlin-Prenzlauer Berg ist eines der größten Wohnbauvorhaben des Entwicklungsgebiets „Alter Schlachthof“ realisiert: das AVILA Carré. Zwischen Eldenaer Straße und Otto-Ostrowski-Straße entstand in drei Bauabschnitten ein vielseitiges Stadtquartier mit insgesamt rund 270 modernen Mietwohnungen, 24 Stadthäusern und gewerblich genutzten Flächen für Einzelhandel, Dienstleistungen und medizinische Versorgung.

  Das Wohnensemble fügt sich in ein historisch bedeutsames Umfeld ein. Der Zentralvieh- und Schlachthof, errichtet ab 1877 nach Plänen von Hermann Blankenstein, war bis in die 1990er Jahre ein zentraler Ort der Berliner Stadtversorgung. Mit der Schließung des Geländes 1995 eröffnete sich die Chance für eine umfassende städtebauliche Neugestaltung, die heute als Vorzeigeprojekt für behutsame Umnutzung und nachhaltige Quartiersentwicklung gilt.

  Das AVILA Carré steht exemplarisch für diese Transformation: eine moderne, lebendige Mischung aus verschiedenen Wohnformen mit sozialem Anspruch. Haus Elija richtet sich vor allem an junge Familien und bietet unterschiedlich geschnittene Wohnungen mit zwei bis fünf Zimmern, offenen Grundrissen, hochwertigen Materialien wie Echtholzparkett sowie großzügigen Panoramafenstern. Haus Edith Stein ist speziell auf seniorengerechtes, barrierefreies Wohnen ausgerichtet und wird in Kooperation mit der Caritas betreut. Haus Johannes vom Kreuz erweitert das Ensemble um weitere Mietwohnungen mit zeitgemäßer Ausstattung.

  Ein besonderer Fokus lag auf der architektonischen Qualität und dem Wohnkomfort und bietet 13 Wohnungstypen mit Wohnflächen zwischen ca. 57 m² und 121 m². Die Ausstattung umfasst neben Fußbodenheizung und modernen Tageslichtbädern auch barrierearme Zugänge, teilweise Aufzüge sowie praktische Grundrisslösungen, die sowohl für Familien als auch für Senioren und Singles geeignet sind. Die Wärmeversorgung erfolgt über Fernwärme.

  Mit seiner zentralen Lage im Schnittpunkt von Friedrichshain, Prenzlauer Berg und Lichtenberg sowie einer hervorragenden Infrastruktur ist das Quartier hervorragend angebunden und bietet zugleich ein ruhiges, familienfreundliches Umfeld. Spielplätze, Grünflächen und eine soziale Durchmischung machen das AVILA Carré zu einem gelungenen Beispiel für zeitgemäßen, verantwortungsbewussten Wohnungsbau auf historischem Grund.`,
    builder: "AVILA Management & Consulting AG",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement",
    projektzeitraum: "2007-2014",
    architekt: "Büro QBQ Quick Bäckmann Quick und Partner, Berlin",
    nutzung: "Mehrgeschossiger Wohnungsbau und Terrassenhäuser",
    wohnflaeche: "ca. 32.626 m²",
    gewerbeflaeche: "ca. 3.089 m²",
    grundstuecksflaeche: "ca. 33.500 m²",
    wohneinheiten: "381",
    gewerbeeinheiten: "20",
    anzahlStellplaetze: "278 Tiefgaragenstellplätze",
    status: "abgeschlossen",
    location:
      "Zur Marktflagge, Agnes-Wabnitz-Straße, Walter-Friedländer-Straße, Otto-Ostrowski-Straße, Zur Innung, Erich-Nehlhans-Str., 10249 Berlin-Friedrichshain",
  },

  {
    id: 12,
    title: "Sanierung und denkmalgeschützter Umbau Villa Brenninkmeyer",
    images: [
      img("officeGrunewald", 1600, "office.webp"),
      img("officeGrunewald", 1600, "office1.webp"),
      img("officeGrunewald", 1600, "office2.webp"),
      img("officeGrunewald", 1600, "office3.webp"),
    ],
    previewImage: img("officeGrunewald", 1600, "office.webp"),
    description: `Die Villa in der Grunewaldstraße 24 im Berliner Ortsteil Steglitz wurde im Jahr 1886 nach Plänen des Architekten Ludwig Kuehn errichtet. Heute ist das freistehende Einfamilienhaus ein eingetragenes Baudenkmal und zählt zu den architektonisch bedeutenden Zeitzeugen des späten 19. Jahrhunderts in Berlin. Das Gebäude liegt in unmittelbarer Nähe zum Botanischen Garten und ist ein prägendes Beispiel für die repräsentative Wohnhausarchitektur der Gründerzeit.

Errichtet in Ziegelbauweise mit Mansarddach, präsentiert sich die Villa mit einer Fassade aus einer Mischung von Putzflächen und Sichtziegeln. In ihrer Größe, Typologie und Konstruktion ist sie typisch für die Bauzeit um 1900. Die bewegte Geschichte des Hauses spiegelt sich auch in der Nutzung wider: Ursprünglich von einem Kaufmann erbaut und bis 1951 als Wohnhaus durch verschiedene Eigentümer bewohnt – zuletzt durch die Familie C. & A. Brenninkmeyer – wurde das Gebäude ab den 1950er Jahren von der katholischen Kirche als Hospiz genutzt. Ab 1963 war der Morusverlag in dem Gebäude ansässig, das dafür umfassend zu einem Verlagshaus umgebaut wurde.

Im Rahmen der denkmalgerechten Sanierung in den Jahren 2006 und 2007 wurde das Gebäude umfassend instandgesetzt, wobei der originale Charakter soweit wie möglich erhalten blieb. Besondere Aufmerksamkeit galt der Instandsetzung der Fassaden, die deutliche Schäden durch Umwelteinflüsse, Mikroorganismen sowie statische Belastungen aufwiesen. Die Putzflächen, deren Zustand durch Risse, Abplatzungen, Blasenbildungen und starken Bewuchs beeinträchtigt war, wurden sorgfältig nach den Vorgaben der DIN 16350 und DIN 16363 überarbeitet. Alle Applikationen und Schmuckelemente des Putzes wurden in enger Abstimmung mit dem Denkmalamt rekonstruiert. Auch das Sichtmauerwerk aus Klinker wurde behutsam gereinigt, schadhafte Ziegel wurden ausgetauscht, lose Fugen erneuert und das Mauerwerk insgesamt aufgearbeitet.

Ein weiterer Schwerpunkt der Sanierung lag auf dem Erhalt und der Wiederherstellung historischer Fenster. Nur wenige originale Kastendoppelfenster blieben an der straßenseitigen Fassade erhalten, die meisten wurden im Zuge der Umnutzung in den 1960er Jahren ersetzt. Die verbliebenen historischen Fenster mit profilierten Pfosten wurden fachgerecht instandgesetzt, einschließlich Fensterbänken, Laibungen und Rollkästen. Neue Holz-Isolierglasfenster wurden an der straßenabgewandten Fassade eingebaut.

Die unterkellerte Villa mit voll ausgebautem Dachgeschoss ist heute als Bürostandort der AVILA Projektmanagement GmbH in Nutzung. Von außen zeigt sich das Gebäude weitgehend im Originalzustand – mit detailreichem Fensterstuck und Reliefverzierungen aus grauem Sandstein. Ziel der Sanierung war es, die historische Substanz zu sichern, originale Bauteile zu erhalten und die Villa in eine zeitgemäße, aber denkmalverträgliche Nutzung zu überführen – ein Vorhaben, das mit hoher Sensibilität für den historischen Wert des Gebäudes realisiert wurde.`,
    builder: "AVILA Management & Consulting AG",
    projektzeitraum: "2007",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement",
    nutzung: "Geschäftshaus",
    status: "abgeschlossen",
    wohnflaeche: "ca. 1.143 m²",
    grundstuecksflaeche: "ca. 1.652 m²",
    wohneinheiten: "15 Büroräume",
    anzahlStellplaetze: "10",
    location: "Grunewaldstraße 24, 12165 Berlin-Steglitz",
  },

  {
    id: 13,
    title: "Neubau eines Wohn- und Bürogebäudes",
    images: [
      img("kleinaustr", 1600, "kleinaustr5.webp"),
      img("kleinaustr", 1600, "kleinaustr5-01.webp"),
      img("kleinaustr", 1600, "kleinaustr5-02.webp"),
    ],
    previewImage: img("kleinaustr", 1600, "kleinaustr5.webp"),
    description: `In der Kleinaustraße 5, im Berliner Bezirk Steglitz-Zehlendorf, entsteht ein hochwertiger Neubau eines dreigeschossigen Wohngebäudes mit ausgebautem Dachgeschoss und einer integrierten Gewerbeeinheit im Erdgeschoss. Das vollunterkellerte Gebäude wird in Massivbauweise errichtet und folgt dem Prinzip einer offenen Bauweise mit einem kristallinen Baukörper.

Die architektonische Gestaltung versteht sich als zeitgemäße Weiterentwicklung des Bautyps Villa. Mit seiner eigenständigen Formensprache und hochwertigen Materialien fügt sich das Gebäude harmonisch in die heterogene Nachbarschaft ein, die überwiegend durch postmoderne, mehrgeschossige Wohnhäuser der späten 1970er-Jahre geprägt ist.

Der Baukörper orientiert sich an der Bauflucht der benachbarten Gebäude, wodurch ein straßenseitiger Vorgarten erhalten bleibt. Die Grundform ist unregelmäßig und weicht bewusst von klassischen 90°-Winkeln ab – ein gestalterisches Element, das dem Gebäude seinen kristallinen Charakter verleiht.

Die barrierefreie Gewerbeeinheit im Erdgeschoss ist ebenerdig zugänglich. Die oberen Wohneinheiten sind über ein Sicherheitstreppenhaus sowie einen Personenaufzug erschlossen. Der Hauseingang liegt zur Straßenseite hin. Im Untergeschoss befinden sich neben den Technikräumen auch Mieterkeller, Lagerräume und ein Fahrradabstellraum zur flexiblen Nutzung.

Die äußere Erscheinung wird durch eine hochwertige Klinkerfassade mit bodentiefen Fenstern geprägt. Das Dach ist als hinterlüftetes Holz-Sparrendach mit unregelmäßiger Neigung ausgeführt, inklusive Zwischensparrendämmung, Dachschalung und einer Stehfalzdeckung aus beschichtetem Zinkblech.`,
    builder: "Dr. Fernando International GmbH",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement",
    architekt: "kadawittfeldarchitektur gmbh",
    nutzung: "Wohn- und Bürogebäude",
    status: "abgeschlossen",
    projektzeitraum: "2022–2025",
    wohneinheiten: "3 Wohneinheiten, 1 Gewerbeeinheit",
    wohnflaeche: "ca. 390 m²",
    grundstuecksflaeche: "ca. 480 m²",
    location: "Kleinaustraße 5, 14169 Berlin - Steglitz-Zehlendorf",
    besonderheit: ["Aufzug vorhanden"],
  },

  {
    id: 14,
    title: "Neubau Wohnensambles „O26“",
    images: [
      img("wannsee", 1600, "wannsee2.webp"),
      img("wannsee", 1600, "wannsee1.webp"),
    ],
    previewImage: img("wannsee", 1600, "wannsee2.webp"),
    description: `
In direkter Lage in Berlin am Großen Wannsee entstand auf einem ehemaligen Villengrundstück mit dem Projekt O26 ein außergewöhnliches und exklusives Wohnensemble aus 26 Häusern (Einzel-, Doppelhäuser und Villen) sowie zwei Geschosswohnungsbauten mit insgesamt 14 Eigentumswohnungen. Die moderne Architektur besticht durch ihre klare Formensprache, hohe Transparenz und die harmonische Einbindung in einen denkmalgeschützten Park mit altem Baumbestand.

Die freistehenden Häuser mit einer Breite von nur sieben Metern erstrecken sich dabei über drei Etagen und mit dem kubischen Baukörper mit begrünten Flachdächern und einer Fassade aus Glas und Torfbrandklinker schaffen ein ruhiges, naturnahes Wohnumfeld mit fließenden Übergängen zwischen Innen- und Außenraum. 

Große Fensterflächen eröffnen weite Blicke ins Grüne, während hochwertige Materialien wie Muschelkalk, Vollholzparkett und Natursteinböden eine warme Wohnatmosphäre erzeugen.

Die rund 200 m² großen Häuser bieten flexible Grundrisse, individuell angepasst an die Wünsche der Bewohner. 

Das Ensemble wird durch ein zweiteiliges Eingangsgebäude mit 14 Eigentumswohnungen ergänzt. Die Wohnungen mit Penthouse-Charakter bieten großzügige Grundrisse mit Größen zwischen rund 135 und 138 Quadratmetern. Mittelpunkt jeder Einheit ist ein weitläufiger Wohn- und Essbereich, ergänzt durch eine offene Küche, einen Balkon, einen Kellerraum sowie optional einen Tiefgaragenstellplatz. Ein Aufzug erschließt alle Etagen barrierefrei.

Mit O26 entstand zwischen 2002 und 2005 ein Wohnquartier, das die Qualitäten des naturnahen Lebens am Wasser mit hochwertiger Architektur verbindet – zurückhaltend im Ausdruck, aber konsequent in der Gestaltung. Die Verzahnung von gebautem Raum und historischer Parklandschaft schafft ein Wohnumfeld mit besonderer Atmosphäre, das gleichermaßen urban wie naturverbunden ist.
`,
    builder:
      "petruswerk Katholische Wohnungsbau- und Siedlungsgesellschaft mbH",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement",
    projektzeitraum: "2002 - 2005",
    architekt: "Büro QBQ Quick Bäckmann Quick und Partner, Berlin",
    nutzung:
      "14 Eigentumswohnungen und 26 Einzel- und Doppelhäuser und Stadtvillen",
    wohnflaeche: "ca. 1.935 m²",
    grundstuecksflaeche: "ca. 24.862 m²",
    anzahlStellplaetze: "14 Tiefgaragenstellplätze",
    status: "abgeschlossen",
    location: "Am Großen Wannsee / Kaiserstraße, 14109 Berlin-Wannsee",
  },

  {
    id: 15,
    title: "Neubau des Schwesternwohnheims „Haus Bethanien“",
    images: [
      img("schwesternwohnen", 1600, "schwest-03.webp"),
      img("schwesternwohnen", 1600, "schwest-02.webp"),
      img("schwesternwohnen", 1600, "schwest-01.webp"),
    ],
    previewImage: img("schwesternwohnen", 1600, "schwest-03.webp"),
    description: `Auf dem Areal des Gesundheits- und Erholungsparks am Müritzufer in Klink entsteht ein Wohnhaus für die Ordensschwestern des Ordens „Little Flower of Bethanien“, die seit 2014 in der Pflege und der Seelsorge der Klinikpatienten der nahegelegenen Müritz Klinik tätig sind. Das neue Wohnheim bietet den Schwestern neben zwei Wohngemeinschaften mit 5 und 6 Zimmern auch Gemeinschaftsräume und Rückzugsorte zwischen Schicht und Gebet sowie Räume zur geistlichen Stärkung, Lesung und inneres Gleichgewicht.

Es handelt sich um ein 3-geschossiges voll unterkellertes Wohngebäude mit Wohngemeinschaften für die Ordensschwestern. In den oberen beiden Geschossen sind die privaten Zimmer der Schwestern angeordnet, während sich im Erdgeschoss die öffentlichen Räumlichkeiten wie ein Büro für Seelsorge und Austausch, eine Kapelle, die Sakristei, eine Gemeinschaftsküche und zwei Gästezimmer befinden. Ein Aufzug innerhalb des Hauses verbindet alle Etagen. Im Untergeschoss sind Technikräume, Waschküche, Lagerflächen sowie ein Archiv zu finden.`,

    builder: "AVILA Management & Consulting AG",
    projektzeitraum: "September 2023 – September 2025",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement, Veranstaltungsorganisation",
    architekt: "GREENLINE Energiedesign",
    nutzung: "Sonderbau, Wohnhaus für Ordensschwestern",
    nutzflaeche: "812 m²",
    wohneinheiten: "2 Wohneinheiten mit 5 und 6 Zimmern + 2 Gästewohnungen",
    grundstuecksflaeche: "ca. 5.220 m²",
    anzahlStellplaetze: "3",
    besonderheit: [
      "Kapelle und Mehrzweckraum",
      "2 Gästewohnungen sind vorhanden",
    ],
    status: "abgeschlossen",
    location: "Am Seeblick 4, 17192 Klink",
  },
  {
    id: 16,
    title:
      "Neubau Mitarbeiterwohnen 63 Wohneinheiten, bestehend aus drei baugleichen Häusern",
    images: [
      img("mitarbeiterwohnungen1", 1600, "mitarbeiterwohnungen-01.webp"),
      img("mitarbeiterwohnungen1", 1600, "mitarbeiterwohnungen-03.webp"),
    ],
    previewImage: img(
      "mitarbeiterwohnungen1",
      1600,
      "mitarbeiter wohnungen 1-01.webp"
    ),
    description: `Auf dem Areal des Gesundheits- und Erholungsparks am Müritzufer in Klink entstehen drei baugleiche, viergeschossige Wohnhäuser mit jeweils 21 Wohneinheiten – insgesamt werden 63 moderne Wohnungen errichtet. Die freistehenden Gebäude umfassen ein Kellergeschoss, ein Erdgeschoss sowie drei Obergeschosse. Jedes Haus ist mit zwei Hauseingängen und jeweils einem Aufzug ausgestattet.

Die Wohnhäuser sollen künftig als Mitarbeiterwohnungen für die Mitarbeitenden der Müritz Klinik und des Dorint Seehotel & Resorts Klink a.d. Müritz zur Verfügung stehen. Maximale Nähe zur Arbeitsstätte und die Zeitersparnis bieten den Mitarbeitenden eine bessere Work-Life-Balance, was mehr Zeit für Erholung oder Familie bedeutet. Eine solide Wohnsituation direkt am Arbeitsplatz steigert die Loyalität und verringert gleichzeitig die Fluktuation.`,
    builder: "St. Marien Grundbesitz GmbH",
    projektzeitraum: "September 2023 – September 2026",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement, Veranstaltungsorganisation",
    architekt: "GREENLINE Energiedesign",
    nutzung: "Wohnungen",
    wohnflaeche: "ca. 3.529 m²",
    grundstuecksflaeche: "ca. 10.106 m²",
    wohneinheiten: "63 Wohnungen",
    anzahlStellplaetze: "63",
    besonderheit: [
      "PV-Anlage auf dem Dach",
      "Carports für Mieter mit PV-Anlage",
    ],
    status: "bau",
    location: "Am Seeblick 5a-b, 6a-b, 7a-b, 17192 Klink",
  },
  {
    id: 17,
    title:
      "Neubau Mitarbeiterwohnen 18 Wohneinheiten, bestehend aus drei baugleichen Häusern",
    images: [
      img("mitarbeiterwohnungen2", 1600, "mitarbeiterwohnungen-01.webp"),
      img("mitarbeiterwohnungen2", 1600, "mitarbeiterwohnungen-05.webp"),
      img("mitarbeiterwohnungen2", 1600, "mitarbeiterwohnungen-07.webp"),
      img("mitarbeiterwohnungen2", 1600, "mitarbeiterwohnungen-04.webp"),
    ],
    previewImage: img(
      "mitarbeiterwohnungen2",
      1600,
      "mitarbeiter wohnungen 2-01.webp"
    ),
    description: `Auf dem Areal des Gesundheits- und Erholungsparks am Müritzufer in Klink entstehen drei baugleiche Gebäude mit jeweils sechs großzügigen Wohnungen. Jedes Haus ist mit einem Aufzug ausgestattet. 
  

Die Appartements zeichnen sich durch großzügige Raumaufteilungen, voll ausgestattete Küchen und private Balkone aus.


Die Wohnhäuser sollen künftig als Mitarbeiterwohnungen für die Mitarbeitenden der Müritz Klinik und des Dorint Seehotel & Resorts Klink a.d. Müritz zur Verfügung stehen.`,

    builder: "AVILA Management & Consulting AG",
    projektzeitraum: "September 2023 – März 2027",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement, Veranstaltungsorganisation",
    architekt: "GREENLINE Energiedesign",
    nutzung: "Wohnen / Hotel",
    wohnflaeche: "ca. 1.795 m²",
    grundstuecksflaeche: "ca. 32.300 m²",
    wohneinheiten: "18",
    anzahlStellplaetze: "",
    besonderheit: ["PV-Anlage auf dem Dach"],
    status: "bau",
    location: "Mittelstraße 1-3, 17192 Klink",
  },
  {
    id: 18,
    title: "Neubau eines Wohn- und Gewerbequartiers, Greifswald",
    location: "Hafenstraße/Marienstraße, 17489 Greifswald",

    description: `Zwischen dem Stadtzentrum Greifswalds und der Bundeswasserstraße Ryck, in unmittelbarer Nähe zum Museumshafen, entsteht auf einem 3,5 ha großen Areal ein vielfältig genutztes Wohn- und Gewerbequartier. In den Jahren 2008 und 2011 erwarb das Petruswerk Teilflächen der ehemaligen Industriebrache sowie den denkmalgeschützten, jedoch baufälligen Speicher, der mittlerweile abgerissen wurde.

Das petruswerk plant ein Wohngebiet mit unterschiedlichen Wohnungsgrößen und Einrichtungen für betreutes Wohnen, Gewerbeeinheiten sowie großzügige Grünflächen und Parkanlagen, die eine hohe Aufenthaltsqualität bieten. 

Das Quartier wird – abgesehen vom Ver- und Entsorgungsverkehr – PKW-frei gestaltet. Eine großzügige Tiefgarage sorgt für die erforderliche Stellplatzversorgung.`,

    images: [
      img("greifswaldquartier", 1600, "greifswald-wohnquartier-01.webp"),
      img("greifswaldquartier", 1600, "greifswald-wohnquartier-03.webp"),
      img("greifswaldquartier", 1600, "greifswald-wohnquartier-04.webp"),
      img("greifswaldquartier", 1600, "greifswald-wohnquartier-06.webp"),
    ],
    previewImage: img(
      "greifswaldquartier",
      1600,
      "greifswald-wohnquartier-01.webp"
    ),

    builder:
      "petruswerk Katholische Wohnungsbau- und Siedlungsgesellschaft mbH",
    projektzeitraum: "2026–2031",
    leistungen:
      "Projektentwicklung, Projektleitung und -steuerung, GU, Objektbetreuung & Gewährleistungsmanagement",
    architekt: "bäckmann architekten & Bräunlin Kolb Architekten GmbH",
    nutzung: "Wohn- und Gewerbenutzung",
    wohneinheiten: "ca. 520",
    wohnflaeche: "ca. 29.640 m²",
    gewerbeflaeche: "ca. 6.490 m²",
    grundstuecksflaeche: "ca. 31.545 m²",
    status: "planung",

    anzahlStellplaetze:
      "320 Stellplätze für PKW in der Tiefgarage, 955 Fahrradstellplätze",
  },
  {
    id: 19,
    title: "Neubau eines Wohn- und Gewerbequartier, Cottbus",
    images: [
      img("cottbus", 1600, "gulbenerstr-cottbus-03.webp"),
      img("cottbus", 1600, "gulbenerstr-cottbus-04.webp"),
      img("cottbus", 1600, "gulbenerstr-cottbus-05.webp"),
      img("cottbus", 1600, "gulbenerstr-cottbus-06.webp"),
    ],
    previewImage: img("cottbus", 1600, "gulbenerstr-cottbus-03.webp"),
    description: `Auf einem ehemaligen Industriegelände, unweit der Technischen Universität Cottbus-Senftenberg entsteht ein modernes, zukunftsorientiertes Wohnquartier.


Im ersten Schritt werden sämtliche Altgebäude vollständig rückgebaut. Anschließend erfolgt eine Bodensanierung, um die Fläche ökologisch für die zukünftige Nutzung vorzubereiten.

Das neue Quartier wird aus fünf freistehenden Wohngebäuden bestehen, die durch eine gemeinsame Tiefgarage miteinander verbunden sind.

Im Fokus des Städtebaulichen Konzepts steht das Modell des Mehrgenerationenwohnens. Geplant sind 124 Studentenapartments, 129 Zwei- bis Drei-Zimmer-Wohnungen und ein Haus für Wohngemeinschaften z.B. für Menschen mit Demenz, das von einem Sozialträger betrieben wird.

Es entsteht ein urbanes Quartier, das gemeinschaftliches Leben, soziale Durchmischung und generationenübergreifende Teilhabe fördert – eingebettet in eine nachhaltige, zeitgemäße Architektur.`,
    builder:
      "Dr. Fernando International GmbH & Avila Grundbesitz GmbH & Co. KG",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung, Gewährleistungsmanagement",
    architekt: "Bräunlin Kolb Architekten GmbH",
    nutzung: "Wohnnutzung",
    status: "planung",
    wohneinheiten: "ca. 250",
    wohnflaeche: "ca. 12.000 m²",

    grundstuecksflaeche: "ca. 7.706 m²",
    anzahlStellplaetze: "111 PKW-Stellplätze, 136 Fahrradstellplätze",
    projektzeitraum: "2026-2030",
    location: "Gulbener Straße 12, 03046 Cottbus",
  },

  {
    id: 20,
    title: "Sanierung eines Wohnhauses mit 38 Wohneinheiten",
    images: ["/media/projects/sanierung1.webp"],
    previewImage: "/media/projects/sanierung1.webp",

    description: `Das um 1920 errichtete Wohnhaus befindet sich in blockrandständiger Lage und wurde in solider Massivbauweise errichtet. Das viergeschossige Gebäude verfügt über ein ausgebautes Mansarddach mit Gauben auf der Straßen- sowie der Hofseite. Die Erschließung erfolgt über drei Treppenaufgänge: Aufgang 161 mit 13 Wohnungen, Aufgang 163 mit 13 Wohnungen und Aufgang 163A mit 12 Wohnungen.

Die tragenden Außenwände sowie die Mittelwand bestehen aus 42 cm starkem Mauerwerk. Die Decken wurden überwiegend als Holzbalkendecken ausgeführt, mit Ausnahme der Kellerdecke, die in Stahlsteinbauweise errichtet wurde. Der Dachstuhl besteht aus einer klassischen Zimmermanns-Holzkonstruktion, wobei der untere Bereich zu Wohnzwecken ausgebaut wurde.

Straßenseitig schließt das Gebäude direkt an den öffentlichen Fußweg an, während sich auf der Hofseite Laubengärten anschließen, die den grünen Innenbereich strukturieren und zur Wohnqualität beitragen.

Alle Fassaden wurden mit einem neuen, mehrlagigen Edelputz in glatter Ausführung versehen. Straßenseitig sorgt eine differenzierte Fassadengestaltung mit Gesimsgittern, Nutenputz und verschiedenen Putzoberflächen für ein ansprechendes Erscheinungsbild. Alle Fenster wurden erneuert und als deckend gestrichene Holz-Isolierglasfenster installiert. Die Profile der neuen Fenster entsprechen den Teilungen und Ansichtsbreiten der Bestandsfenster, sodass der ursprüngliche Charme erhalten bleibt.

Die Wohnungen wurden umfassend modernisiert und den aktuellen Anforderungen angepasst. Dabei entstanden neue, großzügige Wohnküchen mit modernen Grundrissen und Ausstattung. Die Bäder wurden vollständig erneuert und mit hochwertigen Porzellanobjekten wie Waschbecken, WC sowie Badewannen ausgestattet.

Das Dach wurde komplett instandgesetzt: beschädigte Hölzer wurden erneuert und imprägniert. Die gesamte Eindeckung sowie die Verwahrungen und Abdeckungen der Gauben wurden erneuert. Im ausgebauten Mansardbereich wurden alle Dachschrägen und Abseiten nach Abschluss der Sanierung des Dachstuhls mit Gipskartonverkleidungen geschlossen.

Alle Stränge der Medienversorgung wurden vollständig erneuert. Zudem wurde eine Übergabestation für Fernwärme installiert, einschließlich Steigesträngen und weißen Endlackierungen an den Röhrenradiatoren.`,
    builder: "Avila Management & Consulting AG",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement",
    projektzeitraum: "2002",
    architekt: "Ursula Schamberg",
    nutzung: "Geschosswohnungsbau",
    wohnflaeche: "ca. 2.815 m²",
    grundstuecksflaeche: "ca. 1.619 m²",
    wohneinheiten: "38",
    status: "abgeschlossen",
    location: "Großbeerenstraße 161, 163, 163A, 14482 Potsdam-Babelsberg",
  },

  {
    id: 21,
    title: "Sanierung eines Wohnhauses mit 23 Wohneinheiten",
    images: ["/media/projects/sanierung2.webp"],
    previewImage: "/media/projects/sanierung2.webp",

    description: `Das um 1938 errichtete Wohnhaus befindet sich in blockrandständiger Ecklage an der Großbeerenstraße und dem Horstweg in Potsdam. Es umfasst einen viergeschossigen Gebäudeteil an der Großbeerenstraße und einen dreigeschossigen Flügel entlang des Horstwegs. Insgesamt bietet das Gebäude 23 Wohneinheiten, verteilt auf drei Aufgänge: sechs im Horstweg 1, sechs im Horstweg 3 und elf in der Großbeerenstraße 37.

  Das Gebäude wurde in massiver Mauerwerksbauweise errichtet, mit 38 cm starken Außen- und 24 cm starken Innenwänden. Die Decken sind überwiegend als Holzbalkendecken ausgeführt, die Kellerdecke in Stahlsteinbauweise. Der Dachstuhl ist als klassisches Walmdach konstruiert, wobei die Dachgeschosse nicht ausgebaut sind. Das Gebäude ist vollständig unterkellert. 
  
  Straßenseitig grenzt das Gebäude an den Gehweg, während sich auf der Hofseite private Gärten anschließen, die zur Wohnqualität beitragen.

Im Rahmen einer umfassenden Modernisierung wurden alle Wohnungen aufgewertet, ohne den ursprünglichen Charakter des Gebäudes zu verändern. Der Altputz an den Fassaden wurde entfernt, Stahlträger entrostet und mit Rostschutzfarbe behandelt. Die Fassaden erhielten einen neuen, mehrlagigen Edelputz mit feiner Körnung. Fensterlaibungen und Faschen wurden in Glattputz abgesetzt. Fenster, die nicht mehr instandsetzbar waren, wurden durch neue Holz-Isolierglasfenster ersetzt, wobei die Profilierung den Bestandsfenstern entspricht.

Die Putzflächen im Treppenhaus wurden ebenfalls überarbeitet. Alle äußeren Fensterbänke wurden durch Zinkblechabdeckungen ersetzt. Die Wohnungen wurden umfassend modernisiert, wobei Schornsteine für Medienleitungen genutzt, Lüftungsklappen und Kaminanschlüsse vermauert wurden. Wohnungseingangstüren wurden überarbeitet, wobei die Glasausschnitte und Schließsysteme erhalten blieben, jedoch Bänder, Beschläge und Schlösser erneuert wurden.

Die Wände wurden von alten Tapeten und Anstrichen befreit, der Putz ausgebessert und mit Raufasertapete versehen, die anschließend gestrichen wurde. Die Dielenböden wurden instandgesetzt oder teilweise neu verlegt, wobei alle Dielen verdeckt genagelt wurden. Die Bäder wurden vollständig erneuert, mit hochwertigen ausgestattet. Die Installation erfolgte als Vorwandinstallation, die WCs wurden wandhängend mit Unterputzspülkasten ausgeführt. 

Zusätzlich wurde ein Stellplatz für die Waschmaschine mit den notwendigen Anschlüssen in den Bädern oder Küchen eingeplant.`,
    builder: "AVILA Management & Consulting GmbH",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement",
    projektzeitraum: "2002",
    architekt: "Ursula Schamberg",
    nutzung: "Geschosswohnungsbau",
    wohnflaeche: "ca. 1.244 m²",
    grundstuecksflaeche: "ca. 1.122 m²",
    wohneinheiten: "23",
    anzahlStellplaetze: "",
    status: "abgeschlossen",
    location:
      "Großbeerenstraße 37 / Ecke Horstweg 1 und 3, 14482 Potsdam-Babelsberg",
  },
  {
    id: 22,
    title: "Sanierung Wohngebäude Alt Nowawes 85",
    images: ["/media/projects/sanierung3.webp"],
    previewImage: "/media/projects/sanierung3.webp",
    description: `
Das Objekt „Alt Nowawes 85“ ist ein blockrandständiges Wohnhaus mit sieben Mietwohnungen aus dem Jahr 1890 mit vier Geschossen und einem nicht ausgebauten Dachgeschoss. Es ist vollständig unterkellert, abgesehen von der Durchfahrt. Das Gebäude besteht aus 38er und 24er Mauerwerk und hat Holzbalkendecken. Das Gebäude weist eine typische Bauweise der Zeit auf, mit Blockrandbauweise und einem traufständigen „Berliner Dach“. Die Fassaden sind durch einen vorspringenden Glattputz in der Sockelzone horizontal gegliedert.

Im Rahmen der Sanierung wurden alle Fassaden gemäß den Normen DIN 16350 und DIN 16363 überarbeitet, einschließlich der Fenster. Nicht mehr reparable Fenster wurden durch neue Holz-Isolierglasfenster ersetzt, wobei die Profile den ursprünglichen Fenstern entsprechen. Die äußeren Fensterbänke aus Werkstein wurden durch Zinkblechabdeckungen ersetzt.

Im Hof wurden zwei dreigeschossige Balkonanlagen aus Stahlkonstruktionen ergänzt, die an der Fassade sicher verankert sind. Alle Holzteile, insbesondere an den Treppen, wurden frisch gestrichen und bearbeitet. Ein Dachfenster wurde als Ausstieg und Entrauchungsöffnung für das Treppenhaus eingebaut, falls durch die Feuerwehr gefordert. Zudem wurden die Mieterkeller neu aufgeteilt und ein zentraler Heizraum eingerichtet. Die Kellerräume wurden mit neuen Böden versehen, indem Unebenheiten und Fehlstellen im Ziegelpflaster ausgebessert wurden. 

Die Wohnungen wurden umfassend modernisiert, mit optimierten Grundrissen, neuen Bädern und Küchen. Die Bäder wurden komplett erneuert und mit modernen Porzellanobjekten sowie Stahlemail-Wannen und -Duschwannen ausgestattet. Zusätzlich wurden neue Wandbeläge, Türen und eine moderne Schließanlage eingebaut. Die Durchfahrt bleibt als Rettungsweg für die Feuerwehr erhalten.`,
    builder: "AVILA Management & Consulting AG",
    leistungen:
      "Projektentwicklung, Projektsteuerung, GU, Objektbetreuung & Gewährleistungsmanagement",
    projektzeitraum: "2003",
    architekt: "Ursula Schamberg",
    nutzung: "Geschosswohnungsbau",
    wohnflaeche: "ca. 433 m²",
    grundstuecksflaeche: "ca. 949 m²",
    wohneinheiten: "7",
    anzahlStellplaetze: "",
    status: "abgeschlossen",
    location: "Alt Nowawes 85, 14482 Potsdam-Babelsberg",
  },
];
